// 组件
import importImg from '@/components/importImg.vue'
import alterForm from '@/components/alterForm'
// 接口
import { getHotelsCollections, postHotelsAdd } from '@/services/basic-msg.js'
// 其他
import loading from '@/utils/loading.json'
import jsonData from './jsonData'
import constant from '@/utils/constant.js'

export default {
  components: {
    importImg,
    alterForm
  },
  data () {
    return {
      modifyData: {},
      collapseLength: [],
      formData: jsonData.formData
    }
  },
  watch: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      this.collapseLength = [...new Array(this.formData.length).keys()]
      this.$store.state.app.loading = this.$loading(loading)
      getHotelsCollections().then(res => {
        if (res.status === 200) {
          this.formData[0].createDateItem[20].options = res.data.collections.book_types
          this.formData[0].createDateItem[6].options = res.data.collections.sites
          this.formData[0].createDateItem[22].options = res.data.collections.star_rate
          this.formData[0].createDateItem[27].options = res.data.collections.global_labels
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    },
    formSubmit (data) {
      this.$store.state.app.loading = this.$loading(loading)
      const obj = JSON.parse(JSON.stringify(data))
      const params = {
        hotel: obj
      }
      Object.keys(params.hotel).forEach(res => {
        if (typeof params.hotel[res] === 'boolean') {
          if (params.hotel[res] === true) params.hotel[res] = '1'
          if (params.hotel[res] === false) params.hotel[res] = '0'
        }
      })
      postHotelsAdd(params).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: this.$t('message.operateSuccess')
          })
          setTimeout(() => {
            this.$router.push({
              name: 'hotelList'
            })
          }, constant.ROUTER_CHANGE_INTERVAL)
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    }
  }
}
